import type { FC } from 'react';
import React from 'react';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { ASSET_NAME_BOND } from '@alfa-bank/site-invest-emitents-common/src/constants';

import type { IHintPriceContentProps } from './models';
import {
    BOND_PRICE_HINT_FIRST_PARAGRAPH,
    BOND_PRICE_HINT_SECOND_PARAGRAPH,
    COMMON_PRICE_HINT,
} from './constants';

export const HintPriceContentDesktop: FC<IHintPriceContentProps> = ({ assetTypeCode }) =>
    assetTypeCode === ASSET_NAME_BOND ? (
        <>
            <Text styler={{ margin: 0, marginBottom: 16 }} view="primary-small">
                {BOND_PRICE_HINT_FIRST_PARAGRAPH}
            </Text>
            <Text styler={{ margin: 0 }} view="primary-small">
                {BOND_PRICE_HINT_SECOND_PARAGRAPH}
            </Text>
        </>
    ) : (
        <Text styler={{ margin: 0 }} view="primary-small">
            {COMMON_PRICE_HINT}
        </Text>
    );
